import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

import FontFaceObserver from 'fontfaceobserver';

import defConfig from './cjsDefaultConfig';

// import { cjsDialogBox } from './cjsDialogBox';

import * as fJS from './cjsRoot/fJS';
import { cjsSound } from './cjsRoot/cjsSound';
import { cjsGroup } from './cjsRoot/cjsGroup';
import { DynamicClass } from './cjsRoot/cjsBase';

import { cjsDnD } from './cjsEngines/cjsDnD';
import { cjsSorting } from './cjsEngines/cjsSorting';
import { cjsRotate } from './cjsEngines/cjsRotate';

import { cjsConnect } from './cjsEngines/cjsConnect';

import { cjsClock } from './cjsEngines/cjsClock';

import { cjsSelect } from './cjsEngines/cjsSelect';
import { cjsPuzzle } from './cjsEngines/cjsPuzzle';

import { cjsMemo } from './cjsEngines/cjsMemo';
//import { cjsMahjong } from './cjsMahjong';
import { cjsHangman } from './cjsEngines/cjsHangman';

import { cjsMaze } from './cjsEngines/cjsMaze';

export class cjsStage {
  _id;
  _engine;
  _stage;
  _sounds;
  _ticker;
  _touch;
  _width;
  _height;
  _offset;
  _removeInCorrects;
  _bruteForce;
  _autoCheckAllCorrect;
  _removeAllFromBadTarget;
  _correctBlock;
  _otherProperty;
  _mousedown;

  _dev = false;

  _groups;
  movesTo;

  _defConfig;
  _shuffleGroups;
  _fixTab;
  _listener = {};
  _promises;

  constructor(initData, mixin) {
    this._initData = initData;
    this._mixins = mixin;
    // console.log(this._mixins);
    if (typeof initData.defaultConfig === 'string' && initData.defaultConfig.length > 0) {
      let rawdata = {};
      if (process.env.NODE_ENV != 'production' && !process.env.VUE_APP_IS_WEB) {
        const fs = require('fs');
        rawdata = fs.readFileSync('./' + initData.defaultConfig);
      }
      let tmp = _.cloneDeep(defConfig);
      _.merge(defConfig, JSON.parse(rawdata));
      if (fJS.isNumeric(defConfig.container.margin)) {
        defConfig.container.margin = {
          top: defConfig.container.margin,
          left: defConfig.container.margin,
          right: defConfig.container.margin,
          bottom: defConfig.container.margin,
        };
      } else {
        defConfig.container.margin.top = !fJS.isNumeric(defConfig.container.margin.top)
          ? tmp.container.margin.top
          : defConfig.container.margin.top;
        defConfig.container.margin.left = !fJS.isNumeric(defConfig.container.margin.left)
          ? tmp.container.margin.left
          : defConfig.container.margin.left;
        defConfig.container.margin.right = !fJS.isNumeric(defConfig.container.margin.right)
          ? tmp.container.margin.right
          : defConfig.container.margin.right;
        defConfig.container.margin.bottom = !fJS.isNumeric(defConfig.container.margin.bottom)
          ? tmp.container.margin.bottom
          : defConfig.container.margin.bottom;
      }
      if (fJS.isNumeric(defConfig.container.padding)) {
        defConfig.container.padding = {
          top: defConfig.container.padding,
          left: defConfig.container.padding,
          right: defConfig.container.padding,
          bottom: defConfig.container.padding,
        };
      } else {
        SoundJS(defConfig.container.padding.left) ? tmp.container.padding.left : defConfig.container.padding.left;
        defConfig.container.padding.right = !fJS.isNumeric(defConfig.container.padding.right)
          ? tmp.container.padding.right
          : defConfig.container.padding.right;
        defConfig.container.padding.bottom = !fJS.isNumeric(defConfig.container.padding.bottom)
          ? tmp.container.padding.bottom
          : defConfig.container.padding.bottom;
      }
    }
    this._defConfig = _.cloneDeep(defConfig);
    if (typeof this._defConfig.text.font !== 'string' || this._defConfig.text.font.length === 0) {
      this._defConfig.text.font = this._mixins.$store.getters.getDefaultFont;
    }

    if (!this._checkEngine(this.config.mixinEngine)) return false;
    if (!fJS.isNumeric(this.defConfig.speedAnimate)) throw 'Wartość speedAnimate nie jest prawidłowa';

    let fName = [];
    this._fonts = [];
    this._findFonts(this._fonts, fName, this.config);
    if (this._fonts.length === 0 || fName.includes(this._defConfig.text.font) === false)
      this._fonts.push(new FontFaceObserver(this._defConfig.text.font).load());

    if (this.config.isDev === true) {
      this._dev = {};
      this._dev.fps = new createjs.Text('-- fps', 'bold 18px Arial', '#000');
      this._dev.fps.name = '_dev.fps';

      window.onerror = function(error, url, lineNo, columnNo, err) {
        let msg = {};
        switch (typeof error) {
          case 'object':
            msg.title = 'Uncaught Exception: ' + error.code;
            msg.message = error.message;
            break;
          case 'string':
            msg.title = 'Uncaught Exception: ';
            msg.message = error;
            break;
        }

        var message = [
          msg.title,
          'Message: ' + msg.message,
          'URL: ' + url,
          'Line: ' + lineNo,
          'Column: ' + columnNo,
          'Error object: ' + JSON.stringify(err),
        ].join('\n');

        //    alert(message);
        console.log(message);
        return false;
      };
    }
    this._sounds = new cjsSound();
    this._sounds.init();

    console.log(this._sounds);

    this._stage = new createjs.Stage('gameCanvas');

    this.sounds.Sound.alternateExtensions = ['mp3', 'ogg'];
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;

    this._ticker = createjs.Ticker;
    this.ticker.timingMode = createjs.Ticker.RAF;
    this.ticker.framerate = this.defConfig.framerate;
    if (this.ticker.hasEventListener('tick')) this.ticker.removeAllEventListeners();
    this.ticker.addEventListener(
      'tick',
      function(self, e) {
        self.tick(e);
      }.bind({}, this)
    );
  }

  initGame() {
    this.stage.removeAllChildren();
    this.stage.removeAllEventListeners();
    this.sounds.Sound.removeAllSounds();

    this._mousedown = false;
    this.listener = {};
    this.promises = [];

    this._setStage();
    this._loadStage();

    if (createjs.Touch.isSupported()) {
      this._touch = createjs.Touch.enable(this.stage);
      console.log('Touch is supported: ' + createjs.Touch.isSupported());
    }
  }

  runLoad(stage) {
    let bmp = new createjs.Bitmap('./src/renderer/components/TrGame/mixins/cjsImg/loading.gif');
  }

  runFunctionEngine(fnName) {
    DynamicClass.prototype.fn(this._engine, fnName, this);
  }

  checkGameAction() {
    return DynamicClass.prototype.fn(this._engine, 'checkGameAction', this);
  }

  resetGameAction() {
    try {
      delete this._groups;
      delete this.listener;
      delete this._promeses;

      this.initGame();

      //  DynamicClass.prototype.fn(this._engine, 'afterLoadSamples', this);

      DynamicClass.prototype.fn(this._engine, 'resetGameAction', this);
    } catch (e) {
      console.log(e);
    }
  }

  beforeDestroy() {
    try {
      this.resetCheckStatus();
      this.sounds.Sound.removeAllSounds();

      if (this._ticker !== false || this.ticker.hasEventListener('tick')) this._ticker.removeAllEventListeners();

      if (this._touch === true) createjs.Touch.disable(this._stage);

      this._stage.removeAllChildren();
      this._stage.removeAllEventListeners();

      if (Array.isArray(this.movesTo)) this.movesTo.splice(0, this.movesTo.length);
      delete this._groups;
    } catch (e) {
      console.log(e);
    }
  }

  tick(e) {
    if (Array.isArray(this.movesTo) === false) return;
    if (this.movesTo.length > 0) {
      for (let i = 0; i < this.movesTo.length; i++) {
        this._animate(this.movesTo[i], {
          x: this.movesTo[i].pos.x,
          y: this.movesTo[i].pos.y,
          move: true,
        });
        if (this.movesTo[i].x == this.movesTo[i].pos.x && this.movesTo[i].y == this.movesTo[i].pos.y) {
          //    let x = this.movesTo[i].x, y = this.movesTo[i].y;

          this.movesTo.splice(i, 1);
          //    this.removeClone(x, y);
        }
      }
    }

    if (this.dev !== false) {
      this.dev.fps.text = Math.round(createjs.Ticker.getMeasuredFPS()) + ' fps';
    }

    if (typeof this.mousePoint === 'object' && this.mousePoint !== null) {
      if (this.mousedown === true) {
        this.mousePoint.shape.x = this._stage.mouseX - this.offset.x;
        this.mousePoint.shape.y = this._stage.mouseY - this.offset.y;
        this.mousePoint.shape.visible = this.mousePoint.alwaysShow;
      } else {
        this.mousePoint.shape.visible = false;
      }
    }

    DynamicClass.prototype.fn(this.engine, 'tick', this);

    this.stage.update(e);
  }

  getMeasure(p, cont) {
    if (!Array.isArray(cont.children)) {
      let width = fJS.isNumeric(cont.width) ? cont.width : cont.getBounds() !== null ? cont.getBounds().width : 1,
        height = fJS.isNumeric(cont.height) ? cont.height : cont.getBounds() !== null ? cont.getBounds().height : 1;
      console.log(cont);
      if (p.x1 === false || p.x1 > cont.x) p.x1 = cont.x;
      if (typeof cont._rectangle === 'object' && fJS.isNumeric(cont._rectangle.x) && p.x1 > cont._rectangle.x)
        p.x1 = cont._rectangle.x;
      if (p.x2 === false || p.x2 < cont.x + width) p.x2 = cont.x + width;
      if (p.y1 === false || p.y1 > cont.y) p.y1 = cont.y;
      if (typeof cont._rectangle === 'object' && fJS.isNumeric(cont._rectangle.y) && p.y1 > cont._rectangle.y)
        p.y1 = cont._rectangle.y;
      if (p.y2 === false || p.y2 < cont.y + height) p.y2 = cont.y + height;
      if (cont.textBaseline === 'middle') {
        p.y1 -= height;
      }
      if (cont.textAlign === 'left') {
        p.x2 += Math.abs(p.x1);
      }
    } else
      for (let i = 0; i < cont.children.length; i++) {
        let child = cont.children[i],
          width = fJS.isNumeric(child.width) ? child.width : child.getBounds() !== null ? child.getBounds().width : 1,
          height = fJS.isNumeric(child.height)
            ? child.height
            : child.getBounds() !== null
            ? child.getBounds().height
            : 1;
        if (Array.isArray(child.children) && child.children.length > 0) {
          let p1 = { x1: false, x2: false, y1: false, y2: false };
          this.getMeasure(p1, child);
        }
        // if (child.visible === false)

        if (p.x1 === false || p.x1 > child.x) p.x1 = child.x;
        if (typeof child._rectangle === 'object' && fJS.isNumeric(child._rectangle.x) && p.x1 > child._rectangle.x)
          p.x1 = child._rectangle.x;
        if (p.x2 === false || p.x2 < child.x + width) p.x2 = child.x + width;
        if (p.y1 === false || p.y1 > child.y) p.y1 = child.y;
        if (typeof child._rectangle === 'object' && fJS.isNumeric(child._rectangle.y) && p.y1 > child._rectangle.y)
          p.y1 = child._rectangle.y;
        if (p.y2 === false || p.y2 < child.y + height) p.y2 = child.y + height;
        if (child.textBaseline === 'middle') {
          p.y1 -= height;
        }
        if (child.textAlign === 'left') {
          p.x2 += Math.abs(p.x1);
        }
        if (
          typeof child.graphics === 'object' &&
          typeof child.graphics.command === 'object' &&
          child.graphics.command !== null &&
          fJS.isNumeric(child.graphics.command.radius)
        ) {
          if (p.x1 > child.x - child.width) p.x1 = child.x - child.width;
          if (p.x2 < child.x + child.width) p.x2 = child.x + child.width;
          if (p.y1 > child.y - child.height) p.y1 = child.y - child.height;
          if (p.y2 < child.y + child.height) p.y2 = child.y + child.height;
        }
      }
  }

  update() {
    this._stage.update();
  }

  stageMouseDown(e, data) {
    console.log('cjsStage: DOWN');
    let stage = data.cjsStage;
    stage.resetCheckStatus();

    if (stage.mousedown === true) {
      e.stopPropagation();
      return;
    }

    stage.mousedown = true;
    stage.listener.pm = stage._stage.on('pressmove', stage._stageMouseMove, null, false, { cjsStage: stage });

    e.stopPropagation();
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown === false) {
      return false;
    }
  }

  stageMouseUp(e, data) {
    console.log('cjsStage: UP');

    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown !== true) {
      e.stopPropagation();
      return;
    }

    stage.mousedown = false;
    stage._stage.off('pressmove', stage.listener.pm);

    if (typeof stage.mousePoint === 'object' && stage.mousePoint !== null) {
      stage.mousePoint.shape.visible = false;
    }

    if (typeof engine === 'object' && engine !== null) {
      stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');
    }
    e.stopPropagation();
  }

  getObjectUnderPoint(point, all) {
    let gr = false,
      it = false,
      tab = [];

    for (let i = 0; i < this._stage.getObjectsUnderPoint(point.x, point.y).length; i++) {
      let bmp = this._stage.getObjectsUnderPoint(point.x, point.y)[i],
        idGroup = typeof bmp.idGroup === 'string' ? bmp.idGroup : bmp.parent.idGroup,
        idItem = typeof bmp.idItem === 'string' ? bmp.idItem : bmp.parent.idItem;

      if (
        typeof idGroup !== 'string' ||
        typeof idItem !== 'string' ||
        typeof this.groups[idGroup].items !== 'object' ||
        this.groups[idGroup].items === null ||
        typeof this.groups[idGroup].items[idItem] !== 'object' ||
        this.groups[idGroup].items[idItem] === null ||
        this.groups[idGroup].items[idItem].block === true
      )
        continue;

      gr = idGroup;
      it = idItem;
      if (all === true) tab.push({ idGroup: gr, idItem: it });
      else break;
    }

    return gr === false || it === false ? false : all === true ? tab : { idGroup: gr, idItem: it };
  }

  setPropertyStyle(html, style) {
    for (let i in style) {
      html.style.setProperty(i, style[i]);
    }
  }

  get id() {
    return this._id;
  }
  get engine() {
    return this._engine;
  }
  get stage() {
    return this._stage;
  }
  get ticker() {
    return this._ticker;
  }
  get config() {
    return this._initData;
  }
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  get offset() {
    return this._offset;
  }
  get dev() {
    return this._dev;
  }
  get removeInCorrects() {
    return this._removeInCorrects;
  }
  get bruteForce() {
    return this._bruteForce;
  }
  get autoCheckAllCorrect() {
    return this._autoCheckAllCorrect;
  }
  get removeAllFromBadTarget() {
    return this._removeAllFromBadTarget;
  }
  get correctBlock() {
    return this._correctBlock;
  }
  get groups() {
    return this._groups;
  }
  set groups(v) {
    this._groups = v;
  }
  get defConfig() {
    return this._defConfig;
  }
  get otherProperty() {
    return this._otherProperty;
  }
  get mousedown() {
    return this._mousedown;
  }
  set mousedown(v) {
    this._mousedown = v;
  }
  get listener() {
    return this._listener;
  }
  set listener(v) {
    this._listener = v;
  }
  get promises() {
    return this._promises;
  }
  set promises(v) {
    this._promises = v;
  }
  get sounds() {
    return this._sounds;
  }
  set sounds(v) {
    this._sounds = v;
  }

  _findFonts(fonts, fName, obj) {
    for (let key in obj) {
      if (typeof obj[key] === 'object') this._findFonts(fonts, fName, obj[key]);
      if (key === 'font' && fName.includes(obj[key]) === false) {
        fName.push(obj[key]);
        let font = new FontFaceObserver(obj[key]);
        fonts.push(font.load());
      }
    }
  }

  _loadStage() {
    let layout = this.config.configGame.layout,
      rules = this.config.configGame.rulesGame;

    if (typeof this.config.configGame.layout !== 'object' || this.config.configGame.layout === null)
      throw 'Brak konfiguracji elementów gry';
    if (typeof rules !== 'object' || rules === null) throw 'Brak konfiguracji logiki gry';

    this.groups = {};
    this.movesTo = [];
    if (Array.isArray(this.defConfig.container.offset)) throw 'Błędna konfiguracja offset w pliku DefaultConfig';

    this._offsetGroups = [];
    this._offsetGroups.push(this.defConfig.container.offset);

    this._shuffleGroups =
      typeof this.config.configGame.rulesGame.shuffleGroups === 'boolean'
        ? this.config.configGame.rulesGame.shuffleGroups
        : this.defConfig.shuffleGroups;
    this._fixTab =
      this.config.configGame.rulesGame.groupsConfig &&
      this.config.configGame.rulesGame.groupsConfig.positions &&
      Array.isArray(this.config.configGame.rulesGame.groupsConfig.positions.fixTab)
        ? this.config.configGame.rulesGame.groupsConfig.positions.fixTab
        : [];
    //    console.log(this._fixTab);
    this._combineGroups = _.cloneDeep(
      typeof this.config.configGame.rulesGame.combineGroups === 'object' &&
        this.config.configGame.rulesGame.combineGroups !== null
        ? this.config.configGame.rulesGame.combineGroups
        : {}
    );
    this._loadRule(rules, {
      rules: this.config.configGame.rulesGame,
      shuffle: rules.itemsConfig && rules.itemsConfig.shuffle === true ? true : false,
      shuffle2: -1,
      sort: rules.itemsConfig && rules.itemsConfig.sort === true ? true : false,
      sort2: -1,
      block:
        rules.itemsConfig && typeof rules.itemsConfig.block === 'boolean'
          ? rules.itemsConfig.block
          : this.defConfig.itemsConfig.block,
      block2: -1,
      layout: {
        groupsConfig:
          typeof this.config.configGame.layout.groupsConfig === 'object' &&
          this.config.configGame.layout.groupsConfig !== null
            ? _.cloneDeep(this.config.configGame.layout.groupsConfig)
            : {},
        itemsConfig:
          typeof this.config.configGame.layout.itemsConfig === 'object' &&
          this.config.configGame.layout.itemsConfig !== null
            ? _.cloneDeep(this.config.configGame.layout.itemsConfig)
            : {},
      },
      otherProperty:
        typeof this.config.configGame.layout.otherProperty === 'object' &&
        this.config.configGame.layout.otherProperty !== null
          ? _.cloneDeep(this.config.configGame.layout.otherProperty)
          : {},
    });

    cjsGroup.prototype.setCorrects(this.groups);

    if (typeof this._combineGroups === 'object' && Object.keys(this._combineGroups).length >= 1) {
      if (!Array.isArray(this._combineGroups.items) || this._combineGroups.items.length === 0)
        throw 'Brak konfiguracji tablicy items z id grup do złączenia';
      this._createCombineGroup();
    }

    this._createStage();

    for (let gr in this.groups) {
      for (let i in this.groups[gr].items) {
        if (
          typeof this.groups[gr].items[i].otherProperty !== 'object' ||
          typeof this.groups[gr].items[i].otherProperty.setUnder !== 'string' ||
          typeof this.groups[this.groups[gr].items[i].otherProperty.setUnder] !== 'object' ||
          this.groups[this.groups[gr].items[i].otherProperty.setUnder] === null ||
          this.stage.getChildIndex(this.groups[gr]._container) <
            this.stage.getChildIndex(this.groups[this.groups[gr].items[i].otherProperty.setUnder]._container)
        ) {
          continue;
        }
        let indx1 = this.stage.getChildIndex(this.groups[gr]._container),
          indx2 = this.stage.getChildIndex(this.groups[this.groups[gr].items[i].otherProperty.setUnder]._container);

        this.stage.setChildIndex(this.groups[this.groups[gr].items[i].otherProperty.setUnder]._container, indx1);
        this.stage.setChildIndex(this.groups[gr]._container, indx2);
      }
    }

    // console.log(this.groups);
  }

  _loadRule(rules, sets) {
    if (typeof rules.combineGroups === 'object' || rules.combineGroups === null) {
      if (Object.keys(rules.combineGroups).length < 1 || rules.combineGroups === null) {
        this._combineGroups = {};
      } else {
        this._combineGroups = _.cloneDeep(rules.combineGroups);
      }
    }
    let itemsLength = Array.isArray(rules.items) ? rules.items.length : 0;
    let pickItems = fJS.isNumeric(rules.pickItems) && rules.pickItems <= itemsLength ? rules.pickItems : itemsLength;
    let idGroup = rules.idGroup ? rules.idGroup : null;
    let idItem = rules.idItem ? rules.idItem : null;

    if ((idGroup === null && idItem !== null) || (idGroup !== null && idItem === null)) {
      throw 'Błędna konfiguracja gry. Brakuje ustalenia ' +
        (idGroup === null ? 'idGroup dla idItem: ' + idItem : 'idItem dla idGroup: ' + idGroup);
    }

    let layoutGroup = idGroup !== null ? this._findLayoutGroup(idGroup) : false;
    let layoutItem =
      idItem !== null
        ? this._findLayoutItem(idItem, idGroup, layoutGroup !== false ? layoutGroup.items : undefined)
        : false;

    if (layoutGroup === false && idGroup !== null) throw "Brakuje konfiguracji layout'u dla grupy " + idGroup;
    if (layoutGroup !== false) delete layoutGroup.idGroup;
    if (idGroup !== null) {
      this._shuffleGroups = typeof rules.shuffleGroups === 'boolean' ? rules.shuffleGroups : this._shuffleGroups;
      if (rules.groupsConfig && rules.groupsConfig.positions && Array.isArray(rules.groupsConfig.positions.fixTab))
        this._fixTab = _.merge(this._fixTab, rules.groupsConfig.positions.fixTab);
      this._setGroupConfig(idGroup, sets, layoutGroup, rules);
    }

    if (idItem !== null) {
      this._setItemConfig(idGroup, idItem, layoutGroup, layoutItem, rules, sets);
    }

    this._setOffsetGroups(sets, layoutGroup, rules);

    if (idGroup !== null) {
      this.groups[idGroup].setOffsetItems(this, layoutGroup, rules, sets);
    }

    if (sets.block2 !== -1) {
      sets.block = sets.block2;
      sets.shuffle = sets.shuffle2;
      sets.sort = sets.sort2;
    }

    sets.block =
      rules.itemsConfig && typeof rules.itemsConfig.block === 'boolean' ? rules.itemsConfig.block : sets.block;

    if (Array.isArray(rules.items) && rules.items.length > 0) {
      let indx = [];
      if (sets.shuffle) {
        indx = Array.from({ length: rules.items.length }, (v, k) => k);
        indx = _.sampleSize(indx, pickItems);
        let baseIndx = _.shuffle(indx);
        if (indx.length === baseIndx.length && indx.every((v, i) => v === baseIndx[i])) {
          baseIndx = _.reverse(baseIndx);
        }
        indx = baseIndx;
      } else {
        indx = Array.from({ length: pickItems }, (v, k) => k);
      }

      /** @typedef {(boolean)} czy elementy mają być posortowane? */
      if (sets.sort === true) {
        let copy = _.cloneDeep(indx);
        copy.sort(function(a, b) {
          return a - b;
        });
        indx = _.cloneDeep(copy);
      }

      let self = this;
      indx.forEach(function(ind, i) {
        sets.shuffle2 = rules.items[ind].itemsConfig && rules.items[ind].itemsConfig.shuffle === true ? true : false;
        sets.sort2 = rules.items[ind].itemsConfig && rules.items[ind].itemsConfig.sort === true ? true : false;
        sets.block2 = rules.items[ind].itemsConfig && rules.items[ind].itemsConfig.block === true ? true : false;

        self._loadRule(rules.items[ind], _.cloneDeep(sets));
      });

      if (Array.isArray(rules.itemsGarbage)) {
        this._addGarbage(rules, _.cloneDeep(sets));
      }
    }
  }

  _addGarbage(rules, sets) {
    let keysRules = [];

    /*  PĘTLA WYBIERAJĄCA Z RULES.ITEMS ==> jeżeli zostanie wybrane mniej elementów niż jesy w tej tablicy, to brakujące elementy nie zostaną wzięte pod uwagę
       for(let i = 0; i < rules.items.length; i++) {
       if (!keysRules[rules.items[i].idGroup]) keysRules[rules.items[i].idGroup] = [];
       if (keysRules[rules.items[i].idGroup].indexOf(rules.items[i].idItem) === -1) keysRules[rules.items[i].idGroup].push(rules.items[i].idItem);
       }
       */
    for (let i = 0; i < rules.itemsGarbage.length; i++) {
      let gr = this._findLayoutGroup(rules.itemsGarbage[i].idGroup);
      let keysRest = [];
      if (gr === false) throw "Brakuje konfiguracji layout'u dla grupy " + rules.itemsGarbage[i].idGroup;

      // tutaj wybiera wszystkie klucze z layout + przerabia na śmieci item z rules.items
      if (!keysRules[gr.idGroup]) keysRules[gr.idGroup] = [];

      if (typeof this.groups[gr.idGroup] !== 'object' || this.groups[gr.idGroup] === null) {
        let items = [];
        for (let j = 0; j < this.config.configGame.layout.groups.length; j++)
          if (this.config.configGame.layout.groups[j].idGroup === gr.idGroup) {
            for (let k = 0; k < this.config.configGame.layout.groups[j].items.length; k++) {
              this._loadRule(
                _.merge(rules.itemsGarbage[i], {
                  idItem: this.config.configGame.layout.groups[j].items[k].id,
                }),
                _.merge(
                  sets,
                  typeof rules.itemsGarbage[i].itemsConfig === 'object' &&
                    typeof rules.itemsGarbage[i].itemsConfig.block === 'boolean'
                    ? { block: rules.itemsGarbage[i].itemsConfig.block }
                    : {}
                )
              );
            }
            this.groups[gr.idGroup].setOffsetItems(this, gr, rules, sets);
            break;
          }
      }

      for (let key in this.groups[gr.idGroup].items) {
        if (keysRules[gr.idGroup].indexOf(key) === -1) keysRules[gr.idGroup].push(key);
      }

      for (let i = 0; i < gr.items.length; i++) {
        if (keysRules[gr.idGroup].indexOf(gr.items[i].id) === -1) keysRest.push(gr.items[i].id);
      }

      let indx = Array.from({ length: keysRest.length }, (v, k) => k),
        pickItems =
          fJS.isNumeric(rules.itemsGarbage[i].pick) && rules.itemsGarbage[i].pick <= keysRest.length
            ? rules.itemsGarbage[i].pick
            : keysRest.length;
      indx = _.sampleSize(indx, pickItems);
      let baseIndx = _.shuffle(indx);
      if (indx.length === baseIndx.length && indx.every((v, i) => v === baseIndx[i])) {
        baseIndx = _.reverse(baseIndx);
      }
      indx = baseIndx;

      for (let j = 0; j < indx.length; j++) {
        let layoutItem = this._findLayoutItem(keysRest[indx[j]], gr.idGroup, gr.items);
        this._setItemConfig(
          gr.idGroup,
          keysRest[indx[j]],
          gr,
          layoutItem,
          typeof rules.itemsGarbage[i] === 'object' ? rules.itemsGarbage[i].itemsConfig : null,
          sets
        );
      }
    }
  }

  _setOffsetGroups(sets, layoutGroup, rules) {
    if (
      sets.layout &&
      sets.layout.groupsConfig &&
      sets.layout.groupsConfig.positions &&
      sets.layout.groupsConfig.positions.offset !== undefined &&
      sets.layout.groupsConfig.positions.offset !== null
    ) {
      this._checkOffsetGroup(sets.layout.groupsConfig.positions.offset);
    }
    if (
      layoutGroup &&
      layoutGroup.positions &&
      layoutGroup.positions.offset !== undefined &&
      layoutGroup.positions.offset !== null
    ) {
      this._checkOffsetGroup(layoutGroup.positions.offset);
    }
    if (
      sets.rules &&
      sets.rules.groupsConfig &&
      sets.rules.groupsConfig.positions &&
      sets.rules.groupsConfig.positions.offset !== undefined &&
      sets.rules.groupsConfig.positions.offset !== null
    ) {
      this._checkOffsetGroup(sets.rules.groupsConfig.positions.offset);
    }
    if (
      rules &&
      rules.groupsConfig &&
      rules.groupsConfig.positions &&
      rules.groupsConfig.positions.offset !== undefined &&
      rules.groupsConfig.positions.offset !== null
    ) {
      this._checkOffsetGroup(rules.groupsConfig.positions.offset);
    }
  }

  _checkOffsetGroup(tab) {
    let self = this;
    this._offsetGroups.splice(0, this._offsetGroups.length);
    if (Array.isArray(tab)) {
      tab.forEach(function(off) {
        self._offsetGroups.push({
          x: fJS.isNumeric(off.x) ? off.x : self.defConfig.container.offset.x,
          y: fJS.isNumeric(off.y) ? off.y : self.defConfig.container.offset.y,
          column: off.column,
          row: off.row,
        });
      });
    } else {
      this._offsetGroups.push({
        x: fJS.isNumeric(tab.x) ? tab.x : this.defConfig.container.offset.x,
        y: fJS.isNumeric(tab.y) ? tab.y : this.defConfig.container.offset.y,
        column: tab.column,
        row: tab.row,
      });
    }
  }

  _setGroupConfig(idGroup, sets, layoutGroup, rules) {
    if (this.groups[idGroup] === undefined || this.groups[idGroup] === null) {
      this.groups[idGroup] = new cjsGroup({
        id: idGroup,
        block: sets.block,
        sort: sets.sort,
        shuffle: sets.shuffle,
        stage: this,
      });
    }
    this.groups[idGroup].setLayout('background', sets, layoutGroup, rules);
    this.groups[idGroup].setLayout('positions', sets, layoutGroup, rules);
    this.groups[idGroup].setLayout('shadow', sets, layoutGroup, rules);
    //  this.groups[idGroup].offset = null;
    if (this.groups[idGroup].layout.positions && Array.isArray(this.groups[idGroup].layout.positions.fixTab))
      this.groups[idGroup]._fixTab = _.cloneDeep(this.groups[idGroup].layout.positions.fixTab);

    // PADDINGI
    this.groups[idGroup].setMargin('padding', sets, layoutGroup, rules);
    if (!this.groups[idGroup].isAbsolute()) {
      // MARGINESY
      this.groups[idGroup].setMargin('margin', sets, layoutGroup, rules);

      //    this.groups[idGroup].offset = {};
    }
  }

  _setItemConfig(idGroup, idItem, layoutGroup, layoutItem, rules, sets) {
    if (this.groups[idGroup].items[idItem] === undefined || this.groups[idGroup].items[idItem] === null) {
      this.groups[idGroup].addItem({
        id: idItem,
        block: rules && typeof rules.block === 'boolean' ? rules.block : sets ? sets.block : this.groups[idGroup].block,
        correct: rules && Array.isArray(rules.correct) ? _.cloneDeep(rules.correct) : [],
        stage: this,
      });
    } else {
      let exists = false,
        correct = rules && Array.isArray(rules.correct) ? _.cloneDeep(rules.correct) : [];

      for (let i = 0; i < correct.length; i++) {
        let c = correct[i];
        for (let j = 0; j < this.groups[idGroup].items[idItem].correct.length; j++) {
          exists = this.groups[idGroup].isEqual(_.cloneDeep(c), this.groups[idGroup].items[idItem].correct[j])
            ? true
            : exists;
        }

        if (!exists) {
          this.groups[idGroup].items[idItem].correct.push(_.cloneDeep(c));
        }
      }
    }

    this.groups[idGroup].items[idItem].setLayout('background', sets, layoutGroup, layoutItem, rules);
    this.groups[idGroup].items[idItem].setLayout('positions', sets, layoutGroup, layoutItem, rules);
    this.groups[idGroup].items[idItem].setLayout('shadow', sets, layoutGroup, layoutItem, rules);

    this.groups[idGroup].items[idItem].setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);

    //  this.groups[idGroup].items[idItem].offset = null;
    if (
      this.groups[idGroup].items[idItem].layout.positions &&
      fJS.isNumeric(this.groups[idGroup].items[idItem].layout.positions.columns) &&
      this.groups[idGroup].items[idItem].layout.positions.columns > 0
    ) {
      this.groups[idGroup].cols = this.groups[idGroup].items[idItem].layout.positions.columns;
      delete this.groups[idGroup].items[idItem].layout.positions.columns;
    }
    if (
      this.groups[idGroup].items[idItem].layout.positions &&
      fJS.isNumeric(this.groups[idGroup].items[idItem].layout.positions.rows) &&
      this.groups[idGroup].items[idItem].layout.positions.rows > 0
    ) {
      this.groups[idGroup].rows = this.groups[idGroup].items[idItem].layout.positions.rows;
      delete this.groups[idGroup].items[idItem].layout.positions.rows;
    }

    // PADDINGI
    this.groups[idGroup].items[idItem].setMargin('padding', sets, layoutGroup, layoutItem, rules);

    if (!this.groups[idGroup].items[idItem].isAbsolute()) {
      // MARGINESY
      this.groups[idGroup].items[idItem].setMargin('margin', sets, layoutGroup, layoutItem, rules);

      //   this.groups[idGroup].items[idItem].offset = {};
    }

    this.groups[idGroup].items[idItem].create();
  }

  _findLayoutGroup(idGroup) {
    let layout = false;
    this.config.configGame.layout.groups.forEach(function(gr) {
      if (gr.idGroup == idGroup) {
        layout = _.cloneDeep(gr);
      }
    });

    return layout;
  }

  _findLayoutItem(idItem, idGroup, groupItems) {
    let layout = false;
    if (Array.isArray(groupItems) === false) {
      let layout = this._findLayoutGroup(idGroup);
      if (typeof layout === 'object' && layout !== null) groupItems = this._findLayoutGroup(idGroup).items;
    }

    if (Array.isArray(groupItems)) {
      groupItems.forEach(function(item) {
        if (item.id === idItem) {
          layout = _.cloneDeep(item);
          delete layout.id;
        }
      });
      if (layout === false) throw 'Brakuje konfiguracji elementu: ' + idItem + ' w tablicy items dla grupy: ' + idGroup;
    } else throw 'Brakuje konfiguracji tablicy items dla grupy: ' + idGroup;

    return layout;
  }

  _createCombineGroup() {
    let self = this,
      newGroup = '',
      items = {};
    this._combineGroups.items.forEach(function(id) {
      if (typeof self.groups[id] !== 'object' || self.groups[id] === null) throw 'Brak grupy o ID: ' + id;
      newGroup += id;
      items = _.merge(items, self.groups[id].items);
    });

    if (typeof self.groups[newGroup] === 'object' && self.groups[newGroup] !== null) {
      let i = 0;
      while (typeof self.groups[newGroup + i] === 'object' && self.groups[newGroup + i] !== null) {
        i++;
      }
      newGroup += i;
    }

    for (let gr in this.groups) {
      for (let it in this.groups[gr].items) {
        if (Array.isArray(this.groups[gr].items[it].correct) && this.groups[gr].items[it].correct.length > 0) {
          for (let i = 0; i < this.groups[gr].items[it].correct.length; i++) {
            if (this._combineGroups.items.indexOf(this.groups[gr].items[it].correct[i].idGroup) !== -1)
              this.groups[gr].items[it].correct[i].idGroup = newGroup;
          }
        }
      }
    }

    this._setGroupConfig(
      newGroup,
      {
        block:
          this._combineGroups.groupsConfig && typeof this._combineGroups.groupsConfig.block === 'boolean'
            ? this._combineGroups.groupsConfig.block
            : this.config.configGame.rulesGame.itemsConfig &&
              typeof this.config.configGame.rulesGame.itemsConfig.block === 'boolean'
            ? this.config.configGame.rulesGame.itemsConfig.block
            : this.defConfig.itemsConfig.block,
        shuffle:
          this._combineGroups.groupsConfig && typeof this._combineGroups.groupsConfig.shuffle === 'boolean'
            ? this._combineGroups.groupsConfig.shuffle
            : this.config.configGame.rulesGame.itemsConfig &&
              typeof this.config.configGame.rulesGame.itemsConfig.shuffle === 'boolean'
            ? this.config.configGame.rulesGame.itemsConfig.shuffle
            : this.defConfig.itemsConfig.shuffle,
        sort:
          this._combineGroups.groupsConfig && typeof this._combineGroups.groupsConfig.sort === 'boolean'
            ? this._combineGroups.groupsConfig.sort
            : this.config.configGame.rulesGame.itemsConfig &&
              typeof this.config.configGame.rulesGame.itemsConfig.sort === 'boolean'
            ? this.config.configGame.rulesGame.itemsConfig.sort
            : this.defConfig.itemsConfig.sort,
        layout: this.config.configGame.layout,
        rules: this.config.configGame.rulesGame,
      },
      null,
      this._combineGroups
    );

    this.groups[newGroup]._items = _.cloneDeepWith(items, fJS.customizer);

    this._combineGroups.items.forEach(function(id) {
      delete self.groups[id];
    });

    delete this._combineGroups;
  }

  _createStage() {
    let groups = [],
      i = 0;

    for (let gr in this.groups) {
      this.groups[gr].arrangeItems('items');

      for (let i in this.groups[gr].items) {
        if (
          this.groups[gr].items[i].layout.positions.rotation < 0 ||
          this.groups[gr].items[i].layout.positions.rotation > 360
        )
          throw 'Zakres obrotu elementu: ' +
            i +
            ' w grupie: ' +
            gr +
            ' musi być 0 - 360, a nie: ' +
            this.groups[gr].items[i].layout.positions.rotation;

        if (
          typeof this.groups[gr].items[i].otherProperty.registrationPoint === 'object' &&
          this.groups[gr].items[i].otherProperty.registrationPoint !== null
        ) {
          this.groups[gr].items[i].container.regX =
            typeof this.groups[gr].items[i].otherProperty.registrationPoint === 'object' &&
            fJS.isNumeric(this.groups[gr].items[i].otherProperty.registrationPoint.x)
              ? this.groups[gr].items[i].otherProperty.registrationPoint.x
              : this.groups[gr].items[i].container.regX;
          this.groups[gr].items[i].container.regY =
            typeof this.groups[gr].items[i].otherProperty.registrationPoint === 'object' &&
            fJS.isNumeric(this.groups[gr].items[i].otherProperty.registrationPoint.y)
              ? this.groups[gr].items[i].otherProperty.registrationPoint.y
              : this.groups[gr].items[i].container.regY;
          this.groups[gr].items[i].container.x += this.groups[gr].items[i].container.regX;
          this.groups[gr].items[i].container.y += this.groups[gr].items[i].container.regY;
        }
        if (this.groups[gr].items[i].layout.positions.rotation > 0) {
          if (
            typeof this.groups[gr].items[i].otherProperty.registrationPoint !== 'object' ||
            !fJS.isNumeric(this.groups[gr].items[i].otherProperty.registrationPoint.x)
          ) {
            this.groups[gr].items[i].container.regX = this.groups[gr].items[i].width / 2;
            this.groups[gr].items[i].container.regY = this.groups[gr].items[i].height / 2;
            this.groups[gr].items[i].container.x += this.groups[gr].items[i].container.regX;
            this.groups[gr].items[i].container.y += this.groups[gr].items[i].container.regY;
          }

          this.groups[gr].items[i].rotation = _.cloneDeep(this.groups[gr].items[i].layout.positions.rotation);
        }
      }
      if (!this.groups[gr].isAbsolute()) {
        groups.push(gr);
      } else {
        this.groups[gr].create();
      }
    }

    if (groups.length > 0 && this._shuffleGroups) {
      groups = _.shuffle(groups);
    }

    let ab = 0,
      grR = [];
    for (let i = 0; i < groups.length; i++) {
      let gr = groups[i];

      if (ab < this._fixTab.length) {
        if (!fJS.isNumeric(this._fixTab[ab].x) || !fJS.isNumeric(this._fixTab[ab].y))
          throw 'Błędna konfiguracja tablicy współrzędnych dla grup';
        this.groups[gr].pos.x = this._fixTab[ab].x;
        this.groups[gr].pos.y = this._fixTab[ab].y;
        this.groups[gr].type = 'absolute';
        ab++;
      } else {
        grR.push(gr);
      }

      this.groups[gr].create();
    }

    if (grR.length > 0) {
      let colsConfig =
          this.config.configGame.rulesGame.groupsConfig &&
          this.config.configGame.rulesGame.groupsConfig.positions &&
          fJS.isNumeric(this.config.configGame.rulesGame.groupsConfig.positions.columns)
            ? this.config.configGame.rulesGame.groupsConfig.positions.columns
            : this.config.configGame.layout.groupsConfig &&
              this.config.configGame.layout.groupsConfig.positions &&
              fJS.isNumeric(this.config.configGame.layout.groupsConfig.positions.columns)
            ? this.config.configGame.layout.groupsConfig.positions.columns
            : -1,
        rowsConfig =
          this.config.configGame.rulesGame.groupsConfig &&
          this.config.configGame.rulesGame.groupsConfig.positions &&
          fJS.isNumeric(this.config.configGame.rulesGame.groupsConfig.positions.rows)
            ? this.config.configGame.rulesGame.groupsConfig.positions.rows
            : this.config.configGame.layout.groupsConfig &&
              this.config.configGame.layout.groupsConfig.positions &&
              fJS.isNumeric(this.config.configGame.layout.groupsConfig.positions.rows)
            ? this.config.configGame.layout.groupsConfig.positions.rows
            : -1;

      let cols, rows;
      if (colsConfig <= 0 && rowsConfig <= 0) {
        cols = grR.length;
        rows = 1;
      } else if (colsConfig > 0) {
        cols = grR.length > colsConfig ? colsConfig : grR.length;
        rows = Math.ceil(grR.length / cols);
      } else {
        rows = grR.length > rowsConfig ? rowsConfig : grR.length;
        cols = Math.ceil(grR.length / rows);
      }

      for (let i = 0, w = 0, c = 0; i < grR.length; i++, c = i % cols) {
        let gr = grR[i],
          group = this.groups[gr];

        if (i === 0) {
          group.pos.x = group.pos && fJS.isNumeric(group.pos.x) ? group.pos.x : this.defConfig.container.x;
          group.pos.y = group.pos && fJS.isNumeric(group.pos.y) ? group.pos.y : this.defConfig.container.y;
        } else {
          if (c === 0) {
            w++;
            group.pos.x = this.groups[grR[i - cols]].pos.x - this.groups[grR[i - cols]].margin.left;
            group.pos.y =
              this.groups[grR[i - cols]].pos.y +
              this.groups[grR[i - cols]].pos.height -
              this.groups[grR[i - cols]].margin.bottom;
          } else {
            group.pos.x =
              this.groups[grR[i - 1]].pos.x + this.groups[grR[i - 1]].pos.width + this.groups[grR[i - 1]].margin.right;
            if (w === 0)
              group.pos.y =
                this.groups[grR[i - 1]].pos.y -
                this.groups[grR[i - 1]].margin.top -
                (i - cols - 1 >= 0 ? this.groups[grR[i - cols - 1]].margin.bottom : 0);
            else
              group.pos.y =
                this.groups[grR[i - cols]].pos.y +
                this.groups[grR[i - cols]].pos.height -
                (i - cols - 1 >= 0 ? this.groups[grR[i - cols - 1]].margin.bottom : 0);
          }
        }

        group.pos.x += group.margin.left;
        group.pos.y += group.margin.top + (i - cols >= 0 ? this.groups[grR[i - cols]].margin.bottom : 0);
      }

      for (let i = 0, w = 0, c = 0; i < grR.length; i++, c = i % cols) {
        let gr = grR[i],
          group = this.groups[gr];
        if (i > 0 && c === 0) {
          w++;
        }
        this._offsetGroups.forEach(function(off) {
          if (
            (!fJS.isNumeric(off.row) || (fJS.isNumeric(off.row) && w === off.row)) &&
            (!fJS.isNumeric(off.column) || (fJS.isNumeric(off.column) && c === off.column))
          ) {
            group.pos.x += off.x;
            group.offset.x = off.x;
            group.pos.y += off.y;
            group.offset.y = off.y;
          }
        });

        group.create();
      }
    }

    for (let gr in this.groups) {
      this.stage.addChild(this.groups[gr].container);
    }
    /*
      this._ticker = createjs.Ticker;
      this.ticker.timingMode = createjs.Ticker.RAF;
      this.ticker.framerate = this.defConfig.framerate;
      if (this.ticker.hasEventListener('tick'))
         this.ticker.removeAllEventListeners();
      this.ticker.addEventListener('tick', (function (self, e) {
         self.tick(e);
      }).bind({}, this)); */
  }

  _setStage() {
    this._width = fJS.isNumeric(this.config.realWidth)
      ? this.config.realWidth
      : document.getElementById('game-container').offsetWidth;
    this._height = fJS.isNumeric(this.config.realHeight)
      ? this.config.realHeight
      : document.getElementById('game-container').offsetHeight;
    console.log(this.width + ' - ' + this.height);
    this.stage.canvas.width = this.width;
    this.stage.canvas.height = this.height;

    /**
     * Wyliczenie offset'u niezbędnego, żeby układ współrzędnych sceny znajdował się w punkcie 0,0, a nie na środku ekranu
     */
    this._offset = {
      x: this.stage.canvas.width / 2,
      y: this.stage.canvas.height / 2,
    };

    this.stage.x = this._offset.x;
    this.stage.y = this._offset.y;

    this._removeInCorrects =
      typeof this.config.configGame.removeInCorrects === 'boolean'
        ? this.config.configGame.removeInCorrects
        : this.defConfig.removeInCorrects;
    this._bruteForce =
      typeof this.config.configGame.bruteForce === 'boolean'
        ? this.config.configGame.bruteForce
        : this.defConfig.bruteForce;
    this._correctBlock =
      typeof this.config.configGame.correctBlock === 'boolean'
        ? this.config.configGame.correctBlock
        : this.defConfig.correctBlock;
    this._autoCheckAllCorrect =
      typeof this.config.configGame.autoCheckAllCorrect === 'boolean'
        ? this.config.configGame.autoCheckAllCorrect
        : false;
    this._removeAllFromBadTarget =
      typeof this.config.configGame.removeAllFromBadTarget === 'boolean'
        ? this.config.configGame.removeAllFromBadTarget
        : false;

    if (this.dev !== false) {
      this.dev.fps.x = 10;
      this.dev.fps.y = 20;
      this.dev.fps.x -= this._offset.x;
      this.dev.fps.y -= this._offset.y;
      this.stage.addChild(this.dev.fps);
    }

    if (this.config.mainText !== null && typeof this.config.mainText === 'object') {
      var html = document.createElement('div');
      html.id = 'canvasBgr';
      html.innerHTML = this.config.mainText.text;
      this.setPropertyStyle(
        html,
        _.merge(
          {
            //            'position': 'absolute',
            //            'left': '0',
            //            'top': '0',
            //            'width': '100%',
            //           'height': '100%',
            //            'background-size': 'contain',
            //            'background-repeat': 'no-repeat'
          },
          this._mixins.getCustomStyle(this.config.mainText)
        )
      );

      document.getElementById('mainImage').appendChild(html);
      let gg = new createjs.DOMElement(html);
      gg.x =
        (typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.x)
          ? this.config.mainText.positions.x
          : 0) - this.offset.x;
      gg.y =
        (typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.y)
          ? this.config.mainText.positions.y
          : 0) - this.offset.y;
      if (
        typeof this.config.mainText.positions === 'object' &&
        fJS.isNumeric(this.config.mainText.positions.width) &&
        this.config.mainText.positions.width > 0
      )
        gg.width = this.config.mainText.positions.width;
      if (
        typeof this.config.mainText.positions === 'object' &&
        fJS.isNumeric(this.config.mainText.positions.height) &&
        this.config.mainText.positions.height > 0
      )
        gg.height = this.config.mainText.positions.height;
      this.stage.addChildAt(gg, 0);
      this.stage.update();
    }
  }

  _checkEngine(id) {
    if (id == undefined || id == false || id.length == 0) {
      throw 'Nie ma określonego ID gry';
      return false;
    }
    this._id = id;
    switch (id.toLowerCase()) {
      case 'clock':
        this._engine = 'cjsClock';
        break;
      case 'connect':
        this._engine = 'cjsConnect';
        break;
      case 'rotate':
        this._engine = 'cjsRotate';
        break;
      case 'dnd':
        this._engine = 'cjsDnD';
        break;
      case 'sorting':
        this._engine = 'cjsSorting';
        break;
      case 'select':
        this._engine = 'cjsSelect';
        break;
      case 'puzzle':
        this._engine = 'cjsPuzzle';
        break;
      case 'memo':
        this._engine = 'cjsMemo';
        break;
      case 'hangman':
        this._engine = 'cjsHangman';
        break;
      /*     case 'mahjong':
             //              if (this._engine === undefined) this._engine = 'cjsMahjong';
             //              this._inLine = (this._initData.inLine === true) ? true : false;
             //              this._isHidden = (this._initData.isHidden === true) ? true : false;
             //              this._isSelected = { check: false, gr: -1, idx: -1 };
             //              this.matrix = [];
             break; */
      case 'maze':
        this._engine = 'cjsMaze';
        break;
    }

    if (this._engine === undefined || this._engine === false) {
      throw 'Nie ma takiej gry';
      return false;
    } else {
      return true;
    }
  }

  _animate(move, stop) {
    if (stop.move) {
      let count = this.defConfig.speedAnimate;

      if (Math.abs(move.x - stop.x) < count) move.x = stop.x;

      if (move.x < stop.x) move.x += count;
      else if (move.x > stop.x) move.x -= count;

      if (Math.abs(move.y - stop.y) < count) move.y = stop.y;

      if (move.y < stop.y) move.y += count;
      else if (move.y > stop.y) move.y -= count;
    }
  }
}

export const games = {
  //    cjsMahjong,
  cjsDnD,
  cjsSorting,
  cjsRotate,
  cjsConnect,
  cjsClock,
  cjsSelect,
  cjsPuzzle,
  cjsMemo,
  cjsHangman,
  cjsMaze,
};
